import React from "react"
import AccountStore from "../../../stores/AccountStore"
import _ from "lodash"
import * as accountActions from "../../../actions/AccountActions"
import { IHierarchyItem, IGeoLocation } from "../../../models"
import Location from "../../../components/location/Location"
interface IProps {
    hierarchyItem: IHierarchyItem
    readonly: boolean
}

const HierarchyLocation: React.SFC<IProps> = (props: IProps) => {
    const handleChange = (geoLocation: IGeoLocation) => {
        const hierarchyItem = _.cloneDeep(props.hierarchyItem)
        hierarchyItem.IsLocation = geoLocation.IsLocation
        hierarchyItem.IsMicroLocation = geoLocation.IsMicroLocation
        hierarchyItem.Location = geoLocation.Location
        hierarchyItem.MicroLocation = geoLocation.MicroLocation
        hierarchyItem.DisableLocationException = geoLocation.DisableLocationException
        accountActions.updateAccountHierarchyItem(AccountStore.getCurrentAccount().Id, hierarchyItem, false)
    }
    const hierarchyItem = props.hierarchyItem as any
    if (hierarchyItem.level && hierarchyItem.level === -1) return null
    const hierarchyDefinition = AccountStore.getCurrentAccount().HierarchyDefinitions.find(item => item.Id === props.hierarchyItem.HierarchyDefinitionId)

    return (
        <div className="HierarchyLocation">
            <Location
                readonly={props.readonly}
                objectId={props.hierarchyItem.Id}
                disabledGPSLocation={!hierarchyDefinition.EnableLocations}
                disabledMicroLocation={!hierarchyDefinition.EnableMicroLocations}
                geoLocation={props.hierarchyItem}
                handleChangeGeoLocation={handleChange}
            />
        </div>
    )
}

export default HierarchyLocation